import fetcher from 'api/fetcher';

import { translate } from 'hooks/translation/useTrls';

import { removeBannerFromModerationList } from 'store/models/moderation';
import { addMagritteCustomNotification, MagritteNotificationType } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

const rejectBanner = (
    bannerId: number,
    campaignId: number,
    selectedReasons: number[],
    comment: string
): AppThunkAction<void> => {
    return (dispatch, getState) => {
        const trls = getState().translations.trls;

        void fetcher
            .post(`/api/v1/moderation/reject/${bannerId}`, {
                rejectReasons: selectedReasons,
                comment,
            })
            .then(() => {
                dispatch(removeBannerFromModerationList({ campaignId, bannerId }));
                dispatch(
                    addMagritteCustomNotification({
                        type: MagritteNotificationType.Success,
                        text: translate(trls, 'admin.moderation.banner.reject.notification', [bannerId]),
                    })
                );
            })
            .catch(() => {
                dispatch(
                    addMagritteCustomNotification({
                        type: MagritteNotificationType.Error,
                        text: translate(trls, 'admin.moderation.banner.error.notification', [bannerId]),
                    })
                );
            });
    };
};

export { rejectBanner };
